export default function getLastCharacters(input: string, total: number = 7): string {
  if (input.length <= total) {
    return input
  }
  return input.slice(-total)
}
